<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="index()" [steps]="numbers().length" class="block w-full" name="Getallen Splitsen" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="'Welk getal hoort er op de stipjes?'" />

    <div class="flex">
      <rid-content-card class="z-20 mt-74">
        <div class="bg-card-background grid h-48 w-full place-items-center rounded-lg p-4 text-center font-normal">
          @for (p of [pair()]; track p) {
            <p
              animate.enter="wait-300 anim-pop-in"
              animate.leave="anim-fade-out"
              class="font-lexy2000s absolute text-8xl font-black text-black drop-shadow-2xl transition-colors"
            >
              {{ p[0] }}
            </p>
          }
        </div>
      </rid-content-card>

      <svg class="-mx-3 mt-46 h-32" fill="none" height="116" viewBox="0 0 74 116" width="74" xmlns="http://www.w3.org/2000/svg">
        <path d="M69.1255 2.53345L4.31055 112.809" stroke="#CBD5E1" stroke-width="10" />
      </svg>

      <rid-content-card class="z-20 mb-64">
        <div class="bg-card-background grid h-48 w-full place-items-center rounded-lg p-4 text-center font-normal">
          @for (p of [pair()]; track p) {
            <p
              animate.enter="wait-300 anim-pop-in"
              animate.leave="anim-fade-out"
              class="font-lexy2000s absolute text-8xl font-black text-black drop-shadow-2xl transition-colors"
            >
              {{ p[0] + p[1] }}
            </p>
          }
        </div>
      </rid-content-card>

      <svg
        class="-mx-3 mt-46 h-32 -scale-x-100"
        fill="none"
        height="116"
        viewBox="0 0 74 116"
        width="74"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M69.1255 2.53345L4.31055 112.809" stroke="#CBD5E1" stroke-width="10" />
      </svg>

      <rid-content-card [state]="state() === 'ANSWER' ? 'CORRECT' : 'DEFAULT'" class="z-20 mt-74">
        <div
          [class.bg-emerald-100]="state() === 'ANSWER'"
          class="bg-card-background grid h-48 w-full place-items-center rounded-lg p-4 text-center font-normal transition-all"
        >
          @for (p of [pair()]; track p) {
            @if (state() === 'VISIBLE') {
              <p
                animate.enter="wait-300 anim-pop-in"
                animate.leave="anim-fade-out"
                class="font-lexy2000s absolute text-8xl font-black text-black drop-shadow-2xl transition-all"
              >
                ...
              </p>
            }

            @if (state() === 'ANSWER') {
              <p
                animate.enter="wait-300 anim-pop-in"
                animate.leave="anim-fade-out"
                class="font-lexy2000s absolute text-8xl font-black text-emerald-700 drop-shadow-2xl transition-all"
              >
                {{ p[1] }}
              </p>
            }
          }
        </div>
      </rid-content-card>
    </div>

    @if (state() === 'ANSWER') {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
